import { useCallback } from 'react'

import { copyVoiceConfig } from '@/features/domain/territory'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useTexts } from '../useTexts'
import { useController } from './useController'

export function useControllerActions() {
  const texts = useTexts()
  const toast = useNotification()
  const dispatch = useAppDispatch()
  const {
    close,
    updateData,
    data: { id },
  } = useController()

  const onTerritoryChange = useCallback(
    territoryId => updateData({ id: territoryId }),
    [updateData],
  )

  const onConfirm = useCallback(async () => {
    if (!id) return

    try {
      const result = await dispatch(copyVoiceConfig(id))

      if (copyVoiceConfig.rejected.match(result)) {
        throw new Error(result.error.message)
      }

      toast.success(texts.success)

      close?.()
    } catch (e) {
      toast.error(texts.error)
    }
  }, [dispatch, toast, close, texts, id])

  return {
    onTerritoryChange,
    onConfirm,
  }
}
